import { Counter, MyleCounterStyle } from "./Counters";
import { ICounters } from "./ICounters";

/**
 * Represents a set of Portfolio counters.
 * Implements the ICounters interface to track unread Portfolio.
 */
class PortfolioCounters implements ICounters {
    /** The amount of unread new unapproved notes. */
    private readonly unapprovedNotesCount: number;

    /** The amount of unread notes pending supervision. */
    private readonly notesPendingSupervisionCount: number;

    /** The amount of failed faxes. */
    private readonly failedFaxesCount: number;

    /** The amount of errors to sync to the portal. */
    private readonly portalSyncsErrorCount: number;

    /** The amount of actions required for conseil numerique. */
    private readonly actionRequiredCount: number;

    /**
     * Creates an instance of PortfolioCounters.
     * @param {number} unapprovedNotesCount - The amount of unread new unapproved notes.
     * @param {number} notesPendingSupervisionCount - The amount of unread notes pending supervision.
     * @param {number} failedFaxesCount - The amount of failed faxes.
     * @param {number} portalSyncsErrorCount - The amount of errors to sync to the portal.
     * @param {number} actionRequiredCount - The amount of actions required for conseil numerique.
    */
    constructor(
        unapprovedNotesCount: number,
        notesPendingSupervisionCount: number,
        failedFaxesCount: number,
        portalSyncsErrorCount: number,
        actionRequiredCount: number
    ) {
        this.unapprovedNotesCount = unapprovedNotesCount;
        this.notesPendingSupervisionCount = notesPendingSupervisionCount;
        this.failedFaxesCount = failedFaxesCount;
        this.portalSyncsErrorCount = portalSyncsErrorCount;
        this.actionRequiredCount = actionRequiredCount;
    }

    /**
     * Retrieves an array of Counter objects representing each type of Portfolio counter.
     * @returns {Counter[]} An array of counters with their respective value, label and style.
     */
    public getCounters(): Counter[] {
        return [
            new Counter(this.unapprovedNotesCount, "Tooltip_UnapprovedNotes", MyleCounterStyle.blueCircleWithBackground),
            new Counter(this.notesPendingSupervisionCount, "Tooltip_NotesPendingSupervision", MyleCounterStyle.redCircleWithBackground),
            new Counter(this.failedFaxesCount, "Tooltip_FailedFaxes", MyleCounterStyle.redCircleWithBackground),
            new Counter(this.portalSyncsErrorCount, "Tooltip_PortalSyncsError", MyleCounterStyle.redCircleWithBackground),
            new Counter(this.actionRequiredCount, "Tooltip_ConseilNumActionRequired", MyleCounterStyle.blueCircleNoBackground)
        ];
    }

    /**
     * Determines if the counter can be displayed.
     * @returns {boolean} True if the counter can be displayed, otherwise false.
     */
    public showCounters(): boolean {
        return this.unapprovedNotesCount !== 0
            || this.notesPendingSupervisionCount !== 0
            || this.failedFaxesCount !== 0
            || this.portalSyncsErrorCount !== 0
            || this.actionRequiredCount !== 0;
    }
}

export { PortfolioCounters };
